module.exports = __webpack_public_path__ + "media/packs/showroom-feb98e579546e4952e4c9f58672331e5.svg";